var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-custom"},[_c('Breadscrumbs',{attrs:{"links":[
      {
        name: 'BU Page',
        to: {
          name: 'BUPage'
        }
      },
      {
        name: 'Create',
        to: {
          name: 'BUPageCreate',
          query: {
            section: _vm.$route.query.section,
          },
        }
      }
    ]}}),_c('BUPAgeCreateEdit')],1)}
var staticRenderFns = []

export { render, staticRenderFns }